const UPDATE_CART = "UPDATE_CART";  
const UPDATE_CARTSHOPPING = "UPDATE_CARTSHOPPING";
const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
const ADD_PRODUCT = "ADD_PRODUCT";
const UPDATE_PRODUCT = "UPDATE_PRODUCT";
const DELETE_PRODUCT = "DELETE_PRODUCT";
const CLEAR_ALL_PRODUCT = "CLEAR_ALL_PRODUCT";
const SETTLE = "SETTLE";
const ADD_SECKILL_COUNT = "ADD_SECKILL_COUNT";
const REDUCE_SECKILL_COUNT = "REDUCE_SECKILL_COUNT";
const UPDATE_SECKILL_COUNT = "UPDATE_SECKILL_COUNT";
const UPDATE_NEWCARTSHOPPING = "UPDATE_NEWCARTSHOPPING";
const ADD_DROPSHIPPING_PRODUCT = "ADD_DROPSHIPPING_PRODUCT";
const DELETE_DROPSHIPPING_PRODUCT = "DELETE_DROPSHIPPING_PRODUCT";
const  CLEAR_ALL_DROPSHIPPING_PRODUCT = "CLEAR_ALL_DROPSHIPPING_PRODUCT";
const SETTLE_DROPSHIPPING_PRODUCT = "SETTLE_DROPSHIPPING_PRODUCT";
const ADD_DROPSHIPPING_COUNT = "ADD_DROPSHIPPING_COUNT";
const REDUCE_DROPSHIPPING_COUNT = "REDUCE_DROPSHIPPING_COUNT";
const UPDATE_DROPSHIPPING_COUNT = "UPDATE_DROPSHIPPING_COUNT";
export {
    UPDATE_CART, 
    UPDATE_CARTSHOPPING,
    GET_PRODUCT_LIST,
    ADD_PRODUCT,
    UPDATE_PRODUCT,
    DELETE_PRODUCT,
    CLEAR_ALL_PRODUCT,
    SETTLE,
    ADD_SECKILL_COUNT,
    REDUCE_SECKILL_COUNT,
    UPDATE_SECKILL_COUNT,
    UPDATE_NEWCARTSHOPPING,
    ADD_DROPSHIPPING_PRODUCT,
    DELETE_DROPSHIPPING_PRODUCT,
    CLEAR_ALL_DROPSHIPPING_PRODUCT,
    SETTLE_DROPSHIPPING_PRODUCT,
    ADD_DROPSHIPPING_COUNT,
    REDUCE_DROPSHIPPING_COUNT,
    UPDATE_DROPSHIPPING_COUNT
};



// WEBPACK FOOTER //
// ./src/store/cart/mutation-type.js